module.exports = __webpack_public_path__ + "img/Service2.deafe158.svg";